(() => {
  const SELECTORS = {
    drawerSection: '#CartDrawerSection',
    drawer: '[data-cart-drawer]',
    toast: '[data-toast]',
    count: '[data-cart-count]'
  };

  const root = () => (window.BoujeeTheme && window.BoujeeTheme.root) || '/';
  const toast = (message) => {
    const el = document.querySelector(SELECTORS.toast);
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add('is-visible');
    window.clearTimeout(el._boujeeTimer);
    el._boujeeTimer = window.setTimeout(() => el.classList.remove('is-visible'), 2200);
  };

  const lock = (state) => document.body.classList.toggle('is-locked', state);

  const openDrawer = () => {
    const section = document.querySelector(SELECTORS.drawerSection);
    if (!section) return;
    section.classList.add('is-open');
    section.setAttribute('aria-hidden', 'false');
    lock(true);
    const close = section.querySelector('[data-cart-close]');
    if (close) close.focus();
  };

  const closeDrawer = () => {
    const section = document.querySelector(SELECTORS.drawerSection);
    if (!section) return;
    section.classList.remove('is-open');
    section.setAttribute('aria-hidden', 'true');
    lock(false);
  };

  const setCount = async () => {
    try {
      const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll(SELECTORS.count).forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count < 1;
      });
    } catch (_) {}
  };

  const refreshDrawer = async ({ open = false } = {}) => {
    try {
      const response = await fetch(`${root()}?sections=cart-drawer`);
      if (!response.ok) throw new Error('Unable to refresh cart');
      const sections = await response.json();
      const markup = sections['cart-drawer'];
      if (!markup) return;
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const fresh = doc.querySelector(SELECTORS.drawerSection);
      const current = document.querySelector(SELECTORS.drawerSection);
      if (fresh && current) current.replaceWith(fresh);
      await setCount();
      if (open) openDrawer();
    } catch (_) {
      await setCount();
      if (open) window.location.assign(window.BoujeeTheme.cartUrl);
    }
  };

  const addToCart = async (form) => {
    const button = form.querySelector('[type="submit"]');
    const original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(window.BoujeeTheme.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || window.BoujeeTheme.strings.error);
      await refreshDrawer({ open: true });
      toast(window.BoujeeTheme.strings.added);
      const dialog = form.closest('dialog');
      if (dialog && dialog.open) dialog.close();
    } catch (error) {
      toast(error.message || window.BoujeeTheme.strings.error);
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = original; }
    }
  };

  const changeLine = async (line, quantity) => {
    try {
      const response = await fetch(window.BoujeeTheme.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error(window.BoujeeTheme.strings.error);
      await refreshDrawer({ open: true });
    } catch (error) {
      toast(error.message || window.BoujeeTheme.strings.error);
    }
  };

  document.addEventListener('click', (event) => {
    const openCart = event.target.closest('[data-cart-open]');
    if (openCart) { event.preventDefault(); openDrawer(); return; }

    if (event.target.closest('[data-cart-close], [data-cart-overlay]')) { closeDrawer(); return; }

    const menuOpen = event.target.closest('[data-menu-open]');
    if (menuOpen) {
      const menu = document.querySelector('[data-mobile-menu]');
      if (menu) { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); lock(true); }
      return;
    }
    if (event.target.closest('[data-menu-close], [data-menu-overlay]')) {
      const menu = document.querySelector('[data-mobile-menu]');
      if (menu) { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); lock(false); }
      return;
    }

    const quick = event.target.closest('[data-quick-view]');
    if (quick) {
      const dialog = document.getElementById(quick.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    if (event.target.closest('[data-quick-close]')) {
      const dialog = event.target.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { changeLine(Number(remove.dataset.line), 0); return; }
  });

  document.addEventListener('change', (event) => {
    const qty = event.target.closest('[data-cart-quantity]');
    if (qty) changeLine(Number(qty.dataset.line), Math.max(0, Number(qty.value) || 0));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.boujee-product-form');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      const menu = document.querySelector('[data-mobile-menu].is-open');
      if (menu) { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); lock(false); }
    }
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    const src = thumb.dataset.imageSrc;
    const alt = thumb.dataset.imageAlt || '';
    if (src) {
      main.src = src;
      main.alt = alt;
    }
  });
})();
